<template>
<div>
<b-container>
<b-row>
    <b-col>
Dashboard
    </b-col>
    <b-col>
      <table><tr><td><button style="border: none; background: none;" @click="pdf"><i class="fas fa-download "></i>Download</button></td><td>
      <button @click='logout' style="border: none; background: none;"><i class="fas fa-sign-out-alt "></i>Sign-Out</button></td></tr></table>
    </b-col>
</b-row>
<b-row>
    <b-col>

        <b-container fluid>
        <b-row>
            <b-col>
                Total Farmers<br>
                {{this.totalCount}}
            </b-col>
            <b-col>
                Gender<br>
                <table><tr><td><div>Male<br>
              {{this.maleCount}}  
                </div></td><td>
                <div>Female<br>
                {{this.femaleCount}}
                </div></td></tr></table>
            </b-col>
        </b-row>
        <b-row>
            <b-col><div id="chart1"></div></b-col>
            <b-col><div id="chart2"></div></b-col>
        </b-row>
        <b-row>
            <b-col>
                 <p>Farmers In Liberia By County</p>
              <div id="chart5"></div>
            </b-col>
        </b-row>
        <b-row>
            <b-col><div id="chart3"></div></b-col>
        </b-row>
        <b-row>
            <b-col><div id="chart4"></div></b-col>
        </b-row>
        <b-row>
          <div id="print"></div>
        </b-row>

        </b-container>


    </b-col>
</b-row>
</b-container>
</div>
</template>
<script>
import {db, auth} from '../firebase'
import {GoogleCharts} from 'google-charts'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {

  data () {
    return {
      totalCount: 0,
      maleCount: 0,
      femaleCount: 0,
      dArr: [['Primary Crop', 'Percentage']],
      fsArr: [['Farm Size', 'Percentage']],
      riceArray: [['County','Rice Farms']],
      cassavaArray: [['County','Cassava Farms']],
      geoArray: [['County','Farmers']],
      counties: ['County','GBARPOLU','GRAND KRU','MONTSERRADO','RIVER GEE','BOMI','BONG','GRAND BASSA','GRAND CAPE MOUNT', 'GRAND GEDEH','LOFA','MARGIBI','MARYLAND','NIMBA','RIVERCESS','SINOE']
    }
  },
  methods: {
    logout: function(){
          auth.signOut().then(() => {
            this.$router.replace({name: "login"});
            }).catch((error) => {
            // An error happened.
            });
      },
    pdf: function(){
        window.html2canvs = html2canvas
        var pdfdiv = document.createElement('div')
        pdfdiv.setAttribute('id','pdfdiv')
        pdfdiv.setAttribute('width','500px')
        pdfdiv.setAttribute('height','500px')
        pdfdiv.innerHTML = 'AIMS Report'

        var tbl1 = document.createElement('table')
        tbl1.setAttribute('border', '1')
        for(var i = 0; i < this.dArr.length; i++){
        tbl1.innerHTML += '<tr><td>'+ this.dArr[i][0] +'</td><td>'+this.dArr[i][1] +'</td></tr>'
        }
        var tbl2 = document.createElement('table')
        tbl2.setAttribute('border', '1')
        for(var i = 0; i < this.fsArr.length; i++){
        tbl2.innerHTML += '<tr><td>'+ this.fsArr[i][0] +'</td><td>'+this.fsArr[i][1] +'</td></tr>'
        }
        var tbl3 = document.createElement('table')
        tbl3.setAttribute('border', '1')
        for(var i = 0; i < this.riceArray.length; i++){
        tbl3.innerHTML += '<tr><td>'+ this.riceArray[i][0] +'</td><td>'+this.riceArray[i][1] +'</td></tr>'
        }
        var tbl4 = document.createElement('table')
        tbl4.setAttribute('border', '1')
        for(var i = 0; i < this.cassavaArray.length; i++){
        tbl4.innerHTML += '<tr><td>'+ this.cassavaArray[i][0] +'</td><td>'+this.cassavaArray[i][1] +'</td></tr>'
        }
        var tbl5 = document.createElement('table')
        tbl5.setAttribute('border', '1')
        for(var i = 0; i < this.geoArray.length; i++){
        tbl5.innerHTML += '<tr><td>'+ this.counties[i] +'</td><td>'+this.geoArray[i][1] +'</td></tr>'
        }
        
        pdfdiv.appendChild(tbl1)
        pdfdiv.appendChild(tbl2)
        pdfdiv.appendChild(tbl3)
        pdfdiv.appendChild(tbl4)
        pdfdiv.appendChild(tbl5)
        document.getElementById("print").appendChild(pdfdiv)

        var doc = new jsPDF('p','pt','a4')
        doc.html(document.querySelector('#pdfdiv'),{
          callback: function(pdf){
            pdf.save('aimsreport.pdf')
          }
        })
        
    },

    getPCarray: async function () {
      var cArray = ['Rice', 'lowland Rice', 'Cassava', 'Vegetables', 'Other']
      var cCount = [0, 0, 0, 0]
      var sArray = ['1', '2', '> 2']
      var sCount = [0, 0, 0]
      var counties = ['GBARPOLU','GRAND KRU','MONTSERRADO','RIVER GEE','BOMI','BONG','GRAND BASSA','GRAND CAPE MOUNT', 'GRAND GEDEH','LOFA','MARGIBI','MARYLAND','NIMBA','RIVERCESS','SINOE']
      var ps = ['LR-GP','LR-GK','LR-MO','LR-RG','LR-BM','LR-BG','LR-GB','LR-CM','LR-GG','LR-LO','LR-MG','LR-MY','LR-NI','LR-RI','LR-SI']
      var rCount = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
      var cvaCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      var geoValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      // var count = 0

      let result1 = db.collection('oldfarmers')
      let result2 = await result1.get()

      for (const doc of result2.docs) {

          var county = doc.data().county

          if(county === 'GBARPOLU'){
            geoValues[0] += 1
          }else if(county === 'GRAND KRU'){
            geoValues[1] += 1
          }else if(county === 'MONTSERRADO'){
            geoValues[2] += 1
          }else if(county === 'RIVER GEE'){
            geoValues[3] += 1
          }else if(county === 'BOMI'){
            geoValues[4] += 1
          }else if(county === 'BONG'){
            geoValues[5] += 1
          }else if(county === 'GRAND BASSA'){
            geoValues[6] += 1
          }else if(county === 'GRAND CAPE MOUNT'){
            geoValues[7] += 1
          }else if(county === 'GRAND GEDEH'){
            geoValues[8] += 1
          }else if(county === 'LOFA'){
            geoValues[9] += 1
          }else if(county === 'MARGIBI'){
            geoValues[10] += 1
          }else if(county === 'MARYLAND'){
            geoValues[11] += 1
          }else if(county === 'NIMBA'){
            geoValues[12] += 1
          }else if(county === 'RIVER CESS'){
            geoValues[13] += 1
          }else if(county === 'SINOE'){
            geoValues[14] += 1
          }
          

        if (doc.data().primary_crop === 'Rice') {
          cCount[0] += 1

          
          if(county === 'GBARPOLU'){
            rCount[0] += 1
          }else if(county === 'GRAND KRU'){
            rCount[1] += 1
          }else if(county === 'MONTSERRADO'){
            rCount[2] += 1
          }else if(county === 'RIVER GEE'){
            rCount[3] += 1
          }else if(county === 'BOMI'){
            rCount[4] += 1
          }else if(county === 'BONG'){
            rCount[5] += 1
          }else if(county === 'GRAND BASSA'){
            rCount[6] += 1
          }else if(county === 'GRAND CAPE MOUNT'){
            rCount[7] += 1
          }else if(county === 'GRAND GEDEH'){
            rCount[8] += 1
          }else if(county === 'LOFA'){
            rCount[9] += 1
          }else if(county === 'MARGIBI'){
            rCount[10] += 1
          }else if(county === 'MARYLAND'){
            rCount[11] += 1
          }else if(county === 'NIMBA'){
            rCount[12] += 1
          }else if(county === 'RIVER CESS'){
            rCount[13] += 1
          }else if(county === 'SINOE'){
            rCount[14] += 1
          }
          

        } else if (doc.data().primary_crop === 'lowland Rice') {
          
          cCount[1] += 1

          if(county === 'GBARPOLU'){
            rCount[0] += 1
          }else if(county === 'GRAND KRU'){
            rCount[1] += 1
          }else if(county === 'MONTSERRADO'){
            rCount[2] += 1
          }else if(county === 'RIVER GEE'){
            rCount[3] += 1
          }else if(county === 'BOMI'){
            rCount[4] += 1
          }else if(county === 'BONG'){
            rCount[5] += 1
          }else if(county === 'GRAND BASSA'){
            rCount[6] += 1
          }else if(county === 'GRAND CAPE MOUNT'){
            rCount[7] += 1
          }else if(county === 'GRAND GEDEH'){
            rCount[8] += 1
          }else if(county === 'LOFA'){
            rCount[9] += 1
          }else if(county === 'MARGIBI'){
            rCount[10] += 1
          }else if(county === 'MARYLAND'){
            rCount[11] += 1
          }else if(county === 'NIMBA'){
            rCount[12] += 1
          }else if(county === 'RIVER CESS'){
            rCount[13] += 1
          }else if(county === 'SINOE'){
            rCount[14] += 1
          }

        } else if (doc.data().primary_crop === 'Cassava') {
          cCount[2] += 1

          var county = doc.data().county

          if(county === 'GBARPOLU'){
            cvaCount[0] += 1
          }else if(county === 'GRAND KRU'){
            cvaCount[1] += 1
          }else if(county === 'MONTSERRADO'){
            cvaCount[2] += 1
          }else if(county === 'RIVER GEE'){
            cvaCount[3] += 1
          }else if(county === 'BOMI'){
            cvaCount[4] += 1
          }else if(county === 'BONG'){
            cvaCount[5] += 1
          }else if(county === 'GRAND BASSA'){
            cvaCount[6] += 1
          }else if(county === 'GRAND CAPE MOUNT'){
            cvaCount[7] += 1
          }else if(county === 'GRAND GEDEH'){
            cvaCount[8] += 1
          }else if(county === 'LOFA'){
            cvaCount[9] += 1
          }else if(county === 'MARGIBI'){
            cvaCount[10] += 1
          }else if(county === 'MARYLAND'){
            cvaCount[11] += 1
          }else if(county === 'NIMBA'){
            cvaCount[12] += 1
          }else if(county === 'RIVER CESS'){
            cvaCount[13] += 1
          }else if(county === 'SINOE'){
            cvaCount[14] += 1
          }

        } else if (doc.data().primary_crop === 'Vegetables') {
          cCount[3] += 1
        }

        if(parseInt(doc.data().farm_size) != ''){
          console.log(parseInt(doc.data().farm_size))
          if(parseInt(doc.data().farm_size) === 1){
            sCount[0] += 1
          }else if(parseInt(doc.data().farm_size) === 2){
            sCount[1] += 1
          }else{
            sCount[2] += 1
          }
        }

      }

      var tallay = cCount[0] + cCount[1] + cCount[2] + cCount[3]
      var other = this.totalCount - tallay

      cCount.push(other)

      // var wrapper = []

      for (var i = 0; i < cArray.length; i++) {
        this.dArr.push([
          cArray[i], cCount[i]
        ])
        console.log('added')
      }

      for (var i = 0; i < sArray.length; i++) {
        this.fsArr.push([
          sArray[i], sCount[i]
        ])
        console.log('sa added')
      }
      
      for (var i = 0; i < counties.length; i++) {
        this.riceArray.push([
          counties[i], rCount[i]
        ])
        console.log('rc added')
      }
     
     for (var i = 0; i < counties.length; i++) {
        this.cassavaArray.push([
          counties[i], cvaCount[i]
        ])
        console.log('cva added')
      }
    
    for (var i = 0; i < counties.length; i++) {
        this.geoArray.push([
          {v: ps[i], f: counties[i]}, geoValues[i]
        ])
        console.log('geo added')
      }

      // wrapper.push(level2)
      return
      // console.log(this.dArr)
    },

    drawCharts: function () {
    // Standard google charts functionality is available as GoogleCharts.api after load
      
      //console.log('dArr')
      //console.log(this.dArr)
      const data = GoogleCharts.api.visualization.arrayToDataTable(this.dArr)
      const pie1chart = new GoogleCharts.api.visualization.PieChart(document.getElementById('chart1'))
      var options1 = {
        title: 'Distribution of Main Crops In Liberia'
      }
      pie1chart.draw(data, options1)
      
      //console.log('fsArr')
      //console.log(this.fsArr)
      const data2 = GoogleCharts.api.visualization.arrayToDataTable(this.fsArr)
      const pie2chart = new GoogleCharts.api.visualization.PieChart(document.getElementById('chart2'))
      var options2 = {
        title: 'Distribution Of Farm Sizes'
      }
      pie2chart.draw(data2, options2)
    
      //console.log('riceArray')
      //console.log(this.riceArray)
      const data3 = GoogleCharts.api.visualization.arrayToDataTable(this.riceArray)
      const column1chart = new GoogleCharts.api.visualization.ColumnChart(document.getElementById('chart3'))
      var options3 = {
        title: 'Quantity Of Rice By County'
      }
      column1chart.draw(data3, options3)
      
      // console.log('cassavaArray')
      // console.log(this.cassavaArray)
      const data4 = GoogleCharts.api.visualization.arrayToDataTable(this.cassavaArray)
      const column2chart = new GoogleCharts.api.visualization.ColumnChart(document.getElementById('chart4'))
      var options4 = {
        title: 'Quantity Of Cassava By County'
      }
      column2chart.draw(data4, options4)

    
    },

    drawGeoChart: function(){
      
      console.log('geoArray')
      console.log(this.geoArray)

      var data5 = google.visualization.arrayToDataTable(this.geoArray);
      var options5 = {
        region: 'LR',
        resolution: 'provinces',
        displayMode: 'regions'
      };
      var geochart = new google.visualization.GeoChart(document.getElementById('chart5'));
      geochart.draw(data5, options5);
    },

    getTotal: async function () {
     let result1 = db.collection('oldfarmers')
     let result2 = await result1.get()
      
        for(const doc in result2.docs){
          this.totalCount++
        }
  
      let result3 =  db.collection('oldfarmers').where('gender', '==', 'Male')
      let result4 = await result3.get()
            
        for(const doc in result4.docs){
              this.maleCount++
            }
      
      let result5 = db.collection('oldfarmers').where('gender', '==', 'Female')
      let result6 = await result5.get()

          for(const doc in result6.docs){
            this.femaleCount++
          }
    }
  },
  async mounted () {
    await this.getTotal()
    await this.getPCarray()
    
    GoogleCharts.load(this.drawGeoChart, {
    'packages': ['geochart'],
    'mapsApiKey': 'AIzaSyDKcENUZqS8qbGkzyJINcnHBJoJWAcMq8U'
    });
    GoogleCharts.load(this.drawCharts)
  }
}
</script>
<style scoped>

</style>
